export default __webpack_public_path__ + "static/media/keinAnreiz.a1287ad2.png";